// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scan-wrapper {
  position: relative;
  background-color: var(--dark-grey);
  height: 160px;
}
.scan-wrapper ::ng-deep zxing-scanner,
.scan-wrapper ::ng-deep video {
  display: block;
  width: 100% !important;
  height: 160px !important;
  max-height: 160px;
  object-fit: cover;
}

.scan-line {
  position: absolute;
  left: 12px;
  right: 12px;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: var(--ion-color-danger);
  box-shadow: 0 0 6px var(--ion-color-danger);
  z-index: 2;
  pointer-events: none;
}

.input-wrapper {
  border-radius: 4px;
  border: 1px solid var(--dark-grey);
  padding-left: 8px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/barcode-scan-modal/barcode-scan-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kCAAA;EAEA,aAAA;AAAF;AAGE;;EAEE,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,iBAAA;EACA,iBAAA;AADJ;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,2CAAA;EACA,UAAA;EACA,oBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;AAHF","sourcesContent":[".scan-wrapper {\n  position: relative;\n  background-color: var(--dark-grey);\n  // small window, so the modal needs no scrolling\n  height: 160px;\n\n  // the video fills the window (cropped), the barcode is read in the middle of the picture\n  ::ng-deep zxing-scanner,\n  ::ng-deep video {\n    display: block;\n    width: 100% !important;\n    height: 160px !important;\n    max-height: 160px;\n    object-fit: cover;\n  }\n}\n\n// line in the middle, where the code has to be held\n.scan-line {\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  top: 50%;\n  height: 2px;\n  transform: translateY(-50%);\n  background: var(--ion-color-danger);\n  box-shadow: 0 0 6px var(--ion-color-danger);\n  z-index: 2;\n  pointer-events: none;\n}\n\n.input-wrapper {\n  border-radius: 4px;\n  border: 1px solid var(--dark-grey);\n  padding-left: 8px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
